import type { LucideIcon } from 'lucide-react';

export type SectionHeaderAccent = 'primary' | 'secondary' | 'tertiary' | 'success' | 'warning' | 'danger';

const ACCENT_STYLES: Record<SectionHeaderAccent, { bg: string; icon: string }> = {
  primary:   { bg: 'bg-accent-primary/10',   icon: 'text-accent-primary' },
  secondary: { bg: 'bg-accent-secondary/10', icon: 'text-accent-secondary' },
  tertiary:  { bg: 'bg-accent-tertiary/10',  icon: 'text-accent-tertiary' },
  success:   { bg: 'bg-success/10',          icon: 'text-success' },
  warning:   { bg: 'bg-warning/10',          icon: 'text-warning' },
  danger:    { bg: 'bg-danger/10',           icon: 'text-danger' },
};

export interface SectionHeaderProps {
  icon: LucideIcon;
  title: string;
  description?: string;
  accent?: SectionHeaderAccent;
  className?: string;
}

/**
 * Standard nagłówek karty/sekcji w panelach ustawień (Kreator, Ustawienia konta).
 * Ikona w kwadracie z tłem akcentowym + tytuł + opcjonalny opis.
 * Wzorzec wcześniej powtórzony w 12+ miejscach inline.
 */
export function SectionHeader({ icon: Icon, title, description, accent = 'primary', className }: SectionHeaderProps) {
  const styles = ACCENT_STYLES[accent];
  return (
    <div className={['flex items-start gap-4 mb-4', className].filter(Boolean).join(' ')}>
      <div className={['p-3 rounded-xl flex-shrink-0', styles.bg].join(' ')}>
        <Icon className={['w-5 h-5', styles.icon].join(' ')} aria-hidden="true" />
      </div>
      <div className="min-w-0">
        <h3 className="text-lg font-semibold text-text-primary leading-tight">{title}</h3>
        {description && (
          <p className="text-xs text-text-muted mt-1 leading-snug">{description}</p>
        )}
      </div>
    </div>
  );
}
